import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { Environment } from '../../../models/constants/constants';
import { IAppState } from '../../../models/reduxState';
import { articleOnClickHandler } from '../../app/appActions';
import { isAgaveSelector, isNonAgaveSelector, isTeamsSelector, isThirdPartySelector, showAutoSuggestCardSelector, bcqrExperimentTypeSelector, marketSelector, isDarkThemeSelector, openLinksInNewTabSelector, isSignedInSelector, showGetCurrentBoxSelector, isGetHelpSelector, isJumpToFirstLinkEnabledSelector } from '../../app/selectors/contactUsSelector';
import { isTopResultForSelfHelpEnabledSelector, showBCQRV2Selector } from '../../app/selectors/selfHelpSelectors';
import { SelfHelpAlchemy } from '../presentationalComponents/SelfHelpAlchemy';
import { toggleTopResultHeight, toggleTopResultContent } from '../reduxUpdater/actions/selfHelpAlchemyActions';
import { getContactUsStyles } from '../styles/contactUsStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    results: state.ContactState.SelfHelpAlchemyState.alchemyResults,
    runningInSoc: state.GlobalState.environment === Environment.SOC,
    isAlchemyQueryInProgress: state.ContactState.SelfHelpAlchemyState.isAlchemyQueryInProgress,
    isAlchmeySolutionsEnabled: state.ContactState.SelfHelpAlchemyState.isAlchmeySolutionsEnabled,
    isAlchmeyInsightsEnabled: state.ContactState.SelfHelpAlchemyState.isAlchmeyInsightsEnabled,
    isInsightActionButtonEnabled: state.ContactState.SelfHelpAlchemyState.isInsightActionButtonEnabled,
    isJumpToFirstLinkEnabled: isJumpToFirstLinkEnabledSelector(state),
    areSolutionsPresent: state.ContactState.SelfHelpAlchemyState.areSolutionsPresent,
    areInsightsPresent: state.ContactState.SelfHelpAlchemyState.areInsightsPresent,
    areAIInsightsPresent: state.ContactState.SelfHelpAlchemyState.areAIInsightsPresent,
    disambiguationBranchingEnabled: state.ContactState.SelfHelpAlchemyState.disambiguationBranchingEnabled,
    showAutoSuggestCard: showAutoSuggestCardSelector(state),
    bcqrExperimentType: bcqrExperimentTypeSelector(state),
    sourceApp: state.GlobalState.sourceApp,
    showRecommendedArticlesHeader: state.ContactState.SelfHelpAlchemyState.showRecommendedArticlesHeader,
    isThirdParty: isThirdPartySelector(state),
    isTeams: isTeamsSelector(state),
    isAgave: isAgaveSelector(state),
    isNonAgave: isNonAgaveSelector(state),
    isDarkTheme: isDarkThemeSelector(state),
    market: marketSelector(state),
    isSignedIn: isSignedInSelector(state),
    userInfo: state.ContactState.ModalitySectionState.userInfo,
    isTopResultForSelfHelpEnabled: isTopResultForSelfHelpEnabledSelector(state),
    openLinksInNewTab: openLinksInNewTabSelector(state),
    showGetCurrentBox: showGetCurrentBoxSelector(state),
    showBCQRV2: showBCQRV2Selector(state),
    isGetHelp: isGetHelpSelector(state),
  };
};

const mapDispatchToProps = {
  articleOnClickHandler,
  toggleTopResultHeight,
  toggleTopResultContent,
};

export const SelfHelpAlchemyContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(SelfHelpAlchemy, getContactUsStyles));
